<div class="ap-deep-link">
    <a class="ap-deep-link-anchor" [routerLink]="section.route">
        <i class="ph-bold ph-arrow-square-out icon-14" aria-hidden="true"></i>
        <span class="ap-deep-link-label">{{ section.label }}</span>
    </a>
</div>
